import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as authActions from "../pages/AxiosRtk/Auth";
import { useHistory } from "react-router-dom";

import { blockUser, resetBlockUser, clearAuthState } from "../pages/AxiosRtk/Auth";
import { clearDashboard } from "../pages/AxiosRtk/DashBoard";
import { clearAddNewChild } from "../pages/AxiosRtk/AddNewChild";
import { clearMisc } from "../pages/AxiosRtk/Miscellaneous";
import { clearPincode } from "../pages/AxiosRtk/PinCode";
import { clearStorage, setter } from "../../utils/storage";
import { clearTasks } from "../pages/AxiosRtk/Tasks/taskActions";
import { clearSosSettings } from "../pages/AxiosRtk/SosSetting/sosSettingActions";
import { clearSetting } from "../pages/AxiosRtk/Settings/settingAction";
import { clearSetRules } from "../pages/AxiosRtk/SetRules/setRulesAction";
import { clearScreenshotData } from "../pages/AxiosRtk/Screenshot/screenshotActions";
import { clearNudity } from "../pages/AxiosRtk/Nudity/nudityActions";
import { clearLocation } from "../pages/AxiosRtk/Location/locationActions";
import { clearLocateFamily } from "../pages/AxiosRtk/LocateFamily/locateFamilyActions";
import { clearScreenshots } from "../pages/AxiosRtk/KeyWordStats/keyWordStatsActions";
import { clearCopySetting } from "../pages/AxiosRtk/CopySetting/copySettingActions";
import { clearAppActivity } from "../pages/AxiosRtk/AppActivity/appActivityActions";
import { clearAddNewParent } from "../pages/AxiosRtk/AddNewParent/addNewParentActions";
import { clearCallandSms } from "../pages/AxiosRtk/CallSms/callSmsActions";
import useCrypto from "./crypto";

import { setSession, removeSession } from "../../utils/session";
import { setShowMessage, setErrorInfo } from "../pages/AxiosRtk/successMessage";
import useLangTranslation from "./languageProvider";

function useAuthentication() {
  const [socialSignInData, setSocialSignInData] = useState(null);
  const [loader, setLoader] = useState(false);
  const { login, setUser, setIsAdditionalParent } = authActions;
  const { decryptRequest } = useCrypto();
  const { getLangTranslation } = useLangTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  // Use useSelector to get blockUser from the Redux store
  const blockUserState = useSelector((state) => state.auth.blockUser);

  function loginApi(email, password, socialLoginData = null) {
    try {
      const blockedUser = blockUserState[email];

      if (blockedUser && blockedUser.failedCount >= 4) {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: "This email is temporarily blocked. Please try again after 10 minutes.",
            message: "LOGIN_TEMPORARILY_BLOCKED_MESSAGE",
          })
        );
        return;
      }

      setLoader(true);
      const payload = {
        email,
        password,
        deviceType: "WEB",
        roleId: 2,
      };

      if (socialLoginData) {
        payload["socialLoginType"] = 1;
        payload["socialLoginId"] = socialLoginData?.socialLoginId;
        delete payload?.password;
      }

      login(payload)
        .then((res) => {
          setLoader(false);
          dispatch(resetBlockUser(email)); // Reset the block on successful login
          const responseData = res?.data?.result;
          const userDataDec = decryptRequest(res?.data?.result);
          const userDataParsed = JSON.parse(userDataDec);

          setSession("kidoProtectUser", responseData);
          setSession("kidoProtectUserAccessToken", userDataParsed.accessToken);

          if (userDataParsed?.UserRoleID === 4) {
            dispatch(setIsAdditionalParent(true));
            dispatch(
              setShowMessage({
                showMessage: true,
                defaultMessage: "Successful login",
                message: "LOGIN_SUCCESS",
              })
            );

            dispatch(setUser(userDataParsed));

            setter("kidoProtectUser", responseData);
            setter("kidoProtectUserAccessToken", userDataParsed.accessToken);

            removeSession("kidoProtectUser");
            removeSession("kidoProtectUserAccessToken");

            history.push("/dashboard");
          } else {
            if (!userDataParsed?.loginPin) {
              history.push("/auth/emergency-pin-code");
            } else {
              history.push("/auth/enter-pin-code");
            }
          }
        })
        .catch((error) => {
          setLoader(false);
          const failedCount = blockedUser ? blockedUser.failedCount + 1 : 1;
          dispatch(blockUser({ email, failedCount }));

          if (failedCount >= 4) {
            // alert("This email is temporarily blocked. Please try again after 30 seconds.");
            // setTimeout(() => {
            //   dispatch(
            //     setShowMessage({
            //       showMessage: true,
            //       defaultMessage: "This email is temporarily blocked. Please try again after 10 minutes.",
            //       message: "TEMPORARILY_BLOCKED_MESSAGE",
            //     })
            //   );
            // }, 3000);

            // Set a timeout to unblock the user after 30 seconds
            setTimeout(() => {
              dispatch(resetBlockUser(email));
            }, 600000);
          }
          // else {
          //   alert(`Incorrect credentials. You have ${4 - failedCount} attempts left.`);
          // }
          if (error?.response?.data?.message === 'ENTER_CREATE_PASSWORD_FIRST') {
            dispatch(setErrorInfo({
              errorInfo: true,
              title: getLangTranslation('INVALID_CREDENTIAL', error?.response?.data?.message),
              defaultTitle: "Create your password first"
            }));
          } else {
            dispatch(setErrorInfo({
              errorInfo: true,
              title: getLangTranslation('INVALID_CREDENTIAL', error?.response?.data?.message),
              defaultTitle: getLangTranslation('INVALID_CREDENTIAL', error?.response?.data?.message)
            }));
          }
        });
    } catch (e) {
      console.log("Login Catch Error ===>>>", e);
    }
  }

  function handleLogout() {
    dispatch(clearAuthState());
    dispatch(clearDashboard());
    dispatch(clearAddNewChild());
    dispatch(clearMisc());
    dispatch(clearPincode());
    dispatch(clearTasks());
    dispatch(clearSosSettings());
    dispatch(clearSetting());
    dispatch(clearSetRules());
    dispatch(clearScreenshotData());
    dispatch(clearNudity());
    dispatch(clearLocation());
    dispatch(clearLocateFamily());
    dispatch(clearScreenshots());
    dispatch(clearCopySetting());
    dispatch(clearCallandSms());
    dispatch(clearAppActivity());
    dispatch(clearAddNewParent());
    dispatch(clearAddNewChild());
    clearStorage();
    setTimeout(() => {
      window.location.href = "/auth/login";
    }, 1000);
  }

  return {
    socialSignInData,
    setSocialSignInData,
    loader,
    setLoader,
    loginApi,
    handleLogout,
  };
}

export default useAuthentication;
